import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'beneficiari',
  titolo: 'Cercare una persona',
  gruppo: 'Le schede delle persone',
  permesso: 'persona.cerca',
  aCheServe: 'La pagina «Beneficiari» trova le schede delle persone che segui. **Cerca sempre prima di creare '
    + 'una scheda**: la persona può esserci già, anche dal vecchio archivio.',
  parti: [
    {
      titolo: 'Cercare per nome o per numero',
      passi: [
        'Apri «Beneficiari». Il titolo dice quante schede puoi vedere.',
        'Nel campo «Cerca» scrivi nome, cognome, numero di scheda o codice del vecchio archivio (per esempio '
          + '«A100»). La ricerca parte da sola e sopporta piccoli errori di battitura.',
        'Premi il cognome per aprire la scheda.',
      ],
      immagine: {
        file: 'beneficiari-cerca.webp', larghezza: 1200, altezza: 1180,
        descrizione: 'La pagina Beneficiari con il campo Cerca compilato, i filtri e l’elenco delle schede trovate.',
      },
    },
    {
      titolo: 'Cercare per codice fiscale',
      permesso: 'persona.identificativi',
      passi: [
        'Scrivi il codice nel campo «Codice fiscale o altro codice»: codice fiscale, codice provvisorio di 11 '
          + 'cifre, oppure STP, ENI o CUI registrati in «Altri codici».',
        'Si cerca il codice intero. Spazi, trattini e maiuscole non contano.',
      ],
      nota: 'Il codice non resta nell’indirizzo della pagina e il registro eventi annota solo che hai cercato per codice.',
    },
    {
      titolo: 'I filtri',
      testo: [
        'Sotto il campo di ricerca restringi l’elenco: «Area», «Sede», «Stato» della scheda, «Tipologia» e '
          + '«Progetto» dei percorsi, comune, fascia d’età, categoria, «Ente».',
        'Alcuni filtri trovano il lavoro da fare: «Da completare», «Da verificare», «Senza Sede Servizio», '
          + '«Follow up programmato» (persone con un ricontatto in programma).',
        '«Azzera i filtri» li toglie tutti, tranne il testo cercato e il codice. I filtri restano '
          + 'nell’indirizzo della pagina: puoi salvarla fra i preferiti.',
      ],
    },
    {
      titolo: 'Che cosa dicono le righe',
      passi: [
        'Lo «Stato» è scritto a parole: «Completa», «Da completare», «Da completare (vecchio archivio)», «Archiviata».',
        'Il lucchetto «Area riservata» dice che la scheda ha note riservate.',
        'L’etichetta «da verificare» indica una scheda del vecchio archivio con la data di nascita o il codice '
          + 'fiscale da controllare.',
        'Le righe con le sole iniziali sono schede mascherate (sola lettura) oppure con «Dati anonimizzati».',
      ],
    },
  ],
  avvertenze: [
    {
      quando: 'Non trovi una persona che sai essere seguita da CIDIS.',
      cosaFare: 'Premi «Azzera i filtri» e prova con il numero di scheda, il codice del vecchio archivio o il '
        + 'codice fiscale. Se ancora non c’è, la scheda non rientra nei tuoi incarichi, oppure non ha la Sede '
        + 'Servizio e la vede solo chi lavora su tutta CIDIS.',
    },
    {
      quando: 'Trovi due schede della stessa persona.',
      cosaFare: 'Non crearne una terza e non cancellare niente: avvisa la Direzione, che le unisce dalla scheda '
        + 'da tenere con «Unisci con un’altra scheda».',
    },
  ],
  vediAnche: ['nuova-scheda', 'scheda'],
  parole: ['ricerca', 'trovare', 'utenti', 'persone', 'filtro', 'codice fiscale', 'stp', 'eni', 'cui', 'doppione'],
}

export default capitolo
